var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScenery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5a3.003 3.003 0 0 0-3 3v14a3.003 3.003 0 0 0 3 3h14c.182 0 .362-.022.54-.055.066-.012.129-.03.193-.047a2.971 2.971 0 0 0 .531-.187c.084-.04.165-.086.245-.133.075-.044.151-.086.222-.136l.018-.011.021-.018c.014-.011.03-.017.043-.03.007-.006.01-.015.015-.022A2.987 2.987 0 0 0 22 19V5a3.003 3.003 0 0 0-3-3zm.575 18.905A1.95 1.95 0 0 1 19 21H5a2.003 2.003 0 0 1-2-2v-4.725l3.763-3.762a1.753 1.753 0 0 1 2.474 0l3.405 3.404.004.007 6.97 6.969-.041.012zM21 19c0 .516-.202.982-.523 1.337l-6.769-6.768 1.056-1.055a1.787 1.787 0 0 1 2.472 0L21 16.277V19zm0-4.137-3.057-3.056a2.75 2.75 0 0 0-3.886 0L13 12.862 9.944 9.806a2.753 2.753 0 0 0-3.888 0L3 12.86V5a2.003 2.003 0 0 1 2-2h14a2.003 2.003 0 0 1 2 2v9.863zM13.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm0 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenery);
export default __webpack_public_path__ + "static/media/scenery.d907794f.svg";
export { ForwardRef as ReactComponent };